// extracted by mini-css-extract-plugin
module.exports = {"Footer":"MainFooter_Footer__3VEbu","Logo":"MainFooter_Logo__1sbup"};